/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetricsFilters } from './metricsFilters';
import type { ReleaseLine } from './releaseLine';

export interface MetricsContext {
  filters: MetricsFilters;
  releaseLines: ReleaseLine[];
  minN: number;
}
